module.exports = __webpack_public_path__ + "static/youtube_social_icon_red-57c754062bf0068582dffb5e2a35a736.png";